import * as actions from './trackActions'
import constant from '../../constant/appConst'

const trackInit = {}
export default (state = trackInit, action) => {
	switch (action.type) {
		case actions.GET_TRACK_SUCCESS:
			if (action.track) {
				return {
					id: action.track.id,
					title: action.track.title,
					hires: action.track.hires,
					maximum_bit_depth: action.track.maximum_bit_depth,
					maximum_channel_count: action.track.maximum_channel_count,
					maximum_sampling_rate: action.track.maximum_sampling_rate,
					album: action.track.album ? {
						id: action.track.album.id,
						label: action.track.album.label,
						pochette: action.track.album && action.track.album.image ? action.track.album.image.large : undefined,
						title: action.track.album.title,
						genre: action.track.album.genre && action.track.album.genre,
						release_date_original: action.track.album.release_date_original
					} : undefined,
					duration: action.track.duration,
					release_date_stream: action.track.release_date_stream,
					artist: action.track.album && action.track.album.artist ? {
						id: action.track.album.artist.id,
						name: action.track.album.artist.name
					} : undefined,
					composer: action.track.composer,
					work: action.track.work,
					version: action.track.version,
					performer: action.track.performer,
					performers: action.track.performers,
					orderUrl: action.track.articles && action.track.articles.length ? action.track.articles
						.sort((a, b) => (constant.trackQuality[b.type] || 0) - (constant.trackQuality[a.type] || 0))[0].url
						: ''
				}
			}
			return trackInit
		default:
			return state
	}
}



// WEBPACK FOOTER //
// ./src/pages/track/trackReducer.js